import { useState } from "react";
import OptionCard from "./OptionCard";
import moment from "moment";

function TextOptions(props) {
   const [value, setValue] = useState(props.default);
   const { previous, latestSurvey } = props;

   let cn;
   let date = moment(latestSurvey?.created_at).format("DD/MM/YYYY");
   return (
      <div className="flex-c" style={{ flexDirection: "column" }}>

         <div className="custom-radio-button">
            {props.options.map((arr, index) => {

               cn = "";
               if (value) {
                  if (value == arr) {
                     cn = "g-purp";
                  }
               }

               return (
                  // <>
                  //    <OptionCard text={arr} selected={value == arr} disabled={false} onClick={(e) => {
                  //       props.setValue(arr);
                  //       setValue(arr);
                  //    }} />
                  // </>
                  <div className="crb-option-wrapper">
                     {
                        previous == arr && <div className="prev-indicator" />
                     }
                     <div
                        className={`crb-option ${value == arr && "g-border-indigo"}`}
                        onClick={(e) => {
                           props.setValue(arr);
                           setValue(arr);
                        }}
                     >
                        <div className={`crb-option-overlay ${cn}`}>
                           <h5>{arr}</h5>
                        </div>
                     </div>
                  </div>
               );
            })}
         </div >

         {
            previous &&
            <div className="prev-score-wrapper" style={{ marginTop: "175px" }}>
               <div className="prev-indicator" />
               <p className="prev-score" >Previous Rating</p>
               <p className="prev-score" >{date}</p>
               {/* <h6 className="prev-score" style={{ marginTop: "180px" }}>Previous Score({date}): {previous}</h6> */}
            </div>
         }

      </div >
   );
}

export default TextOptions;